import { useContext, useState } from "react";
import { QUESTIONS } from "../../api/Api";
import TimeAndAnswers from "../questionPage/helper/TimeAndAnswers";
import CopyToClipboard from "react-copy-to-clipboard";
import { UserContext } from "../../context/UserContext";
import QuestionManagement from "../dropItemsManagement/QuestionManagement";
import AnswersBox from "./AnswersBox";
import AnswerForm from "./AnswerForm";
import { getColor } from "../HelpFullFunction";
import { useQuery } from "@tanstack/react-query";
import useStore from "../../Store/useStore";
import CircleDrop from "../CircleDrop";
import { useIsSelectedQuestion, useQuestionId, useSelectAQuestion, useSetQuestionId } from "../../Store/QuestionSlice";
import { Axios } from "../../Axios/createAxios";

export default function SelectedQuestion() {
  const { userInfo } = useContext(UserContext);
  const [isOpenMana, setIsOpenMana] = useState(false);
  const [copySuccess, setCopySuccess] = useState(null);
  const isSelectedQuestion = useIsSelectedQuestion();
  const selectedQuestion = useSelectAQuestion();
  const setQuestionId = useSetQuestionId();
  const id = useQuestionId();

  const question = async () => {
    try {
      const res = await Axios.get(`/${QUESTIONS}/${id}`);
      return res;
    } catch (err) {
      throw err;
    }
  };
  const { isLoading, data, status } = useQuery({
    queryFn: question,
    queryKey: ["selectedQuestion"],
    enabled: id !== 0,
    onSuccess: (data) => {
      console.log(data);
    },
    cacheTime: 0,
    staleTime: 0,
    onError: (e) => console.log(e),
  });
  console.log(status, "status");
  console.log(id);

  console.log(data?.data?.data);

  const handleCopy = (questionId) => {
    setCopySuccess(questionId);

    setTimeout(() => {
      setCopySuccess(null);
    }, 2000);
  };

  const Question = () => {
    const questionData = data?.data.data;
    const question = questionData.question;
    const creatorName = questionData.user.name;
    const tagName = questionData.tag && questionData.tag.tag && questionData.tag.tag;
    const userId = questionData.user_id;
    const userPoints = questionData.user.points;
    const questionId = questionData.id;
    const createdAt = questionData.created_at;
    const answersLength = questionData.answers_count;
    return (
      <div className={`${"selected-question-page d-flex flex-column align-items-center gap-4 full-w"}`}>
        <div className={`relative gap-4 pl-10 pr-10 user-question-box`}>
          <header className="user-info">
            <div className={`d-grid sec-c gap-6 ${creatorName === userInfo.name ? "" : ""}`}>
              <span className={`txt-center text-size-100`}>{creatorName}</span>
              <span className="succ-c text-size-90">{userPoints}xp</span>
            </div>
            <CopyToClipboard text={questionId} onCopy={() => handleCopy(questionId)}>
              <span className="mixed-c pointer absolute center-x text-size-90">
                Id:{questionId}
                {questionId === copySuccess && " Copied"}
              </span>
            </CopyToClipboard>
            <CircleDrop onClick={() => setIsOpenMana(true)} />
            <QuestionManagement userId={userId} isOpen={isOpenMana} setIsOpen={setIsOpenMana} />
          </header>
          <p className="text-size-100 word-break sec-c cc" style={{ whiteSpace: "pre-line" }}>
            {question}
            <span
              className="sec-bg-c inline-block pl-5 pr-5 radius-3 ml-5 text-size-90  prime-c"
              style={{
                color: question.tag ? getColor(question.tag.id, 1) : null,
              }}>
              <>{tagName}</>
            </span>
          </p>
          <TimeAndAnswers
            box="question"
            view={"back to posts"}
            onClick={() => {
              setQuestionId(0);
              selectedQuestion(false);
            }}
            time={createdAt}
            length={answersLength}
          />
        </div>
        <AnswersBox />
        <AnswerForm />
      </div>
    );
  };

  return !isLoading && isSelectedQuestion ? Question() : <></>;
}
